// extracted by mini-css-extract-plugin
export default {"input-error":"CustomInput_input-error__Jq3AQ"};